import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import CustomTextField from "../../Components/CustomTextField";
import CustomDropDown from "../../Components/CustomDropDown";
import CustomLoader from "../../Components/CustomLoader";
import moment from "moment/moment";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import { toast } from "react-toastify";
import NotificationIcon from "../../Assets/notifications.png";
import Loader from "../../Components/Loader";
import { useInView } from "react-intersection-observer";
import EditIcon from "@mui/icons-material/Edit";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: "0px 0px 0px 0px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const Notifications = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    // handleTabClick(newValue === 0 ? 1 : 2, newValue === 0 ? 0 : 1);
  };
  const { ref, inView, entry } = useInView({
    threshold: 0,
  });
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [paginationLoader, setPaginationLoader] = useState(false);
  const [data, setData] = useState([]);
  const [editingNotification, setEditingNotification] = useState(null);
  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      selectType: 2,
      dateTime: "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Please enter notification title")
        .max(60, "Title cannot be more than 60 characters"),
      description: Yup.string().required("Please enter description"),
      selectType: Yup.number().required("Please select at least one"),
      dateTime: Yup.string().test(
        "dateTime",
        "Please select a valid schedule date and time",
        function (value) {
          const { selectType } = this.parent;
          if (selectType === 1) {
            const currentTime = moment();
            return moment(value).isAfter(currentTime) || !value;
          }
          return true;
        }
      ),
    }),
    onSubmit: async (values, { resetForm }) => {
      const formattedDateTime = moment(formik?.values?.dateTime)
        .utc()
        .format("YYYY-MM-DD HH:mm:ss")
        .toString();
      setLoading(true);
      try {
        const apiEndpoint = editingNotification
          ? ApiList?.EDIT_NOTIFICATION
          : ApiList?.SEND_NOTIFICATION;
        const response = await AxiosInstance.post(
          `${
            editingNotification
              ? `${apiEndpoint}/${editingNotification?.id}`
              : apiEndpoint
          }`,
          {
            title: values?.title,
            message: values?.description,
            type: values?.selectType,
            date_time: formattedDateTime,
          }
        );
        if (response?.data?.s === 1) {
          resetForm();
          setEditingNotification(null);
          toast.success(
            editingNotification
              ? "Notification updated successfully"
              : "Notification sent successfully"
          );
          handleTabClick(1, 0);
        } else {
          console.log(response?.data?.m);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error);
      }
    },
  });
  const selectValues = [
    {
      id: 1,
      name: "Schedule",
    },
    {
      id: 2,
      name: "Now",
    },
  ];
  const handleTabClick = async (type, isSent, count = 0) => {
    setIsLoading(true);
    setPaginationLoader(true);
    try {
      const params = {
        select: "*",
        from: "admin_notification",
        arg:
          type === 2 && isSent === 1
            ? `status = ? and is_sent = ${isSent}`
            : `status = ? and type = ${type} and is_sent = ${isSent}`,
        prms: [1],
        order: "id DESC",
        skip: count,
        limit: 30,
        total: 1,
      };
      const res = await AxiosInstance.post(ApiList?.USER_GET, params);
      if (res?.data?.s === 1) {
        setData((prev) =>
          count === 0 ? res?.data?.r : [...prev, ...res?.data?.r]
        );
        if (params.skip === 0) {
          const totalCount = res?.data?.total || 0;
          localStorage.setItem("totalCount", totalCount);
          setTotalData(totalCount);
        } else {
          const totalCountFromStorage = localStorage.getItem("totalCount");
          setTotalData(
            totalCountFromStorage ? Number(totalCountFromStorage) : 0
          );
        }
      } else {
        setTotalData(0);
        setData([]);
      }
      setIsLoading(false);
      setPaginationLoader(false);
    } catch (error) {
      setIsLoading(false);
      setPaginationLoader(false);
    }
  };
  useEffect(() => {
    handleTabClick(1, 0);
  }, []);
  useEffect(() => {
    if (
      inView &&
      !paginationLoader &&
      !loading &&
      !isLoading &&
      data?.length < totalData
    ) {
      handleTabClick(data?.length);
    }
  }, [inView, data?.length]);
  const byDate = (data || []).reduce((obj, item) => {
    const messageDate = moment(item?.updated_at || item?.created_at);
    let displayDate;
    if (messageDate?.isSame(moment(), "day")) {
      displayDate = "Today";
    } else if (messageDate.isSame(moment().subtract(1, "days"), "day")) {
      displayDate = "Yesterday";
    } else {
      displayDate = messageDate.format("DD/MM/YYYY");
    }
    if (obj[displayDate]) {
      obj[displayDate].push(item);
    } else {
      obj[displayDate] = [{ ...item }];
    }
    return obj;
  }, {});

  const handleEditClick = (item) => {
    setEditingNotification(item);
    formik.setValues({
      title: item.title,
      description: item.message,
      selectType: item.type,
      dateTime: moment(item.date_time).format("YYYY-MM-DDTHH:mm"),
    });
  };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "100%", p: 2, background: "#B9CC0310" }}>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            Notification Management
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "calc(100vh - 74px)",
            display: "flex",
            gap: "20px",
          }}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              formik.handleSubmit();
              return false;
            }}
            style={{ width: "100%" }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                p: 1,
                flexDirection: "column",
                gap: "10px",
                height: "100%",
                overflow: "auto",
              }}
            >
              <CustomTextField
                placeholder={"Enter notification title"}
                label={"Notification title"}
                type={"text"}
                name="title"
                value={formik.values.title}
                onBlur={formik.handleBlur}
                onKeyUp={formik.handleBlur}
                errors={formik.touched.title && formik.errors.title}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.trimStart() !== value) {
                    e.target.value = value.trimStart();
                  }
                  formik.handleChange(e);
                }}
              />
              <CustomTextField
                placeholder={"Enter description"}
                label={"Description"}
                type={"text"}
                name="description"
                multiline={true}
                rows={5}
                sx={{ height: "auto" }}
                value={formik.values.description}
                onBlur={formik.handleBlur}
                onKeyUp={formik.handleBlur}
                errors={formik.touched.description && formik.errors.description}
                onChange={(e) => {
                  const { value } = e.target;
                  if (value.trimStart() !== value) {
                    e.target.value = value.trimStart();
                  }
                  formik.handleChange(e);
                }}
              />
              <CustomDropDown
                title={"Select"}
                menuList={selectValues}
                value={formik?.values?.selectType}
                onChange={(e) =>
                  formik.setFieldValue("selectType", e?.target?.value)
                }
                onBlur={formik.handleBlur}
                onKeyUp={formik.handleBlur}
              />
              {formik?.values?.selectType === 1 ? (
                <Box sx={{ width: "100%" }}>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      textAlign: "left",
                      fontSize: "14px",
                      color: "#FFFFFF60",
                    }}
                  >
                    Select Time
                  </Typography>
                  <input
                    type="datetime-local"
                    name="dateTime"
                    id=""
                    value={formik?.values?.dateTime}
                    onChange={(e) => {
                      formik.setFieldValue("dateTime", e.target.value);
                    }}
                    style={{
                      background: "#fff",
                      color: "white",
                      borderRadius: "10px",
                      height: "50px",
                      border: "none",
                      outline: "none",
                      padding: "0px 15px",
                      width: "100%",
                      marginTop: "5px",
                    }}
                  />
                  {formik.touched.dateTime && formik.errors.dateTime ? (
                    <Typography
                      sx={{
                        color: "red",
                        fontWeight: "400",
                        fontSize: { xs: "12px", sm: "12px" },
                        marginTop: "5px",
                      }}
                    >
                      {formik.errors.dateTime}
                    </Typography>
                  ) : null}
                </Box>
              ) : null}
              <Box sx={{ width: "100%", display: "flex" }}>
                <Box sx={{ width: "150px", p: 0 }}>
                  <CustomLoader
                    type={"submit"}
                    sx={{ p: 0.5, borderRadius: "10px", background: "#B9CC03" }}
                    btnTitle={editingNotification ? "Update" : "Send"}
                    loading={loading}
                    circleSx={{ color: "#B9CC03" }}
                  />
                </Box>
              </Box>
            </Box>
          </form>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              m: 1,
              p: 1,
              flexDirection: "column",
              gap: "10px",
              overflow: "auto",
              borderRadius: "10px",
              // background: "#00000050",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "100%",
                p: 2,
              }}
            >
              <Typography sx={{ color: "#000", fontSize: "26px" }}>
                Notifications History
              </Typography>
            </Box>
            <Box sx={{ marginTop: "71px", height: "calc(100% - 75px)" }}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  overflow: "scroll",
               
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="content management tabs"
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: "#B9CC03", // Color of the underline
                      
                    },
                  }}
                >
                  <Tab
                    onClick={() => handleTabClick(1, 0)}
                    label="Scheduled"
                    {...a11yProps(0)}
                    sx={{
                      textTransform: "capitalize",
                      color: "white", // Default color for unselected
                      "&.Mui-selected": {
                        color: "#B9CC03",
                      },
                    }}
                  />
                  <Tab
                    onClick={() => handleTabClick(2, 1)}
                    label="Completed"
                    {...a11yProps(1)}
                    sx={{
                      textTransform: "capitalize",
                      color: "white", // Default color for unselected
                      "&.Mui-selected": {
                        color: "#B9CC03", // Color for selected tab text
                      },
                    }}
                  />
                </Tabs>

                <TabPanel value={value} index={0}>
                  {isLoading && data?.length === 0 ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: { xs: "300px", xl: "600px" },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Loader />
                    </Box>
                  ) : (
                    data?.length > 0 &&
                    Object.entries(byDate).map(([date, x], i) => (
                      <>
                        <Typography sx={{ color: "#FFFFFF70", pt: 1 }}>
                          {date}
                        </Typography>
                        {x?.map((item, index) => {
                          let format = moment(item?.date_time).format(
                            "hh:mm A"
                          );
                          return (
                            <Box
                              sx={{
                                width: "100%",
                                p: 2,
                                my: 1,
                                borderRadius: "10px",
                                background: "#fff",
                                display: "flex",
                                gap: "10px",
                                alignItems: "start",
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Notification Icon */}

                              <Box sx={{ width: "30px", height: "30px" }}>
                                <img
                                  src={NotificationIcon}
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    marginTop: "5px",
                                  }}
                                />
                              </Box>

                              {/* Notification Content */}
                              <Box
                                sx={{
                                  width: "calc(100% - 50px)",
                                  flex: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                  alignItems: "start",
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Title */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      width: "calc(100% - 80px)",
                                      color: "#000",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      wordWrap: "break-word",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {item?.title}
                                  </Typography>
                                  <Box
                                    sx={{
                                      width: "80px",
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: "#000",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {format}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Message */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#000",
                                      fontWeight: "100",
                                      fontSize: "14px",
                                      width: "calc(100% - 40px)",
                                      wordWrap: "break-word",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {item?.message}
                                  </Typography>
                                  <IconButton
                                    sx={{ p: 0 }}
                                    onClick={() => handleEditClick(item)}
                                  >
                                    <EditIcon sx={{ color: "white" }} />
                                  </IconButton>
                                </Box>
                              </Box>
                            </Box>
                          );
                        })}
                      </>
                    ))
                  )}
                  {
                    <Box
                      ref={ref}
                      sx={{
                        width: "100%",
                        display: "flex",
                        // display:"flex",
                        // border:"solid red",
                        height: "20px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {paginationLoader && inView && <Loader />}
                    </Box>
                  }
                </TabPanel>

                <TabPanel value={value} index={1}>
                  {isLoading && data?.length === 0 ? (
                    <Box
                      sx={{
                        width: "100%",
                        height: { xs: "300px", xl: "600px" },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Loader />
                    </Box>
                  ) : (
                    data?.length > 0 &&
                    Object.entries(byDate).map(([date, x], i) => (
                      <>
                        <Typography sx={{ color: "#FFFFFF70", pt: 1 }}>
                          {date}
                        </Typography>
                        {x?.map((item, index) => {
                          let format = moment(item?.date_time).format(
                            "hh:mm A"
                          );
                          return (
                            <Box
                              sx={{
                                width: "100%",
                                p: 2,
                                my: 1,
                                borderRadius: "10px",
                                background: "#fff",
                                display: "flex",
                                gap: "10px",
                                alignItems: "start",
                                justifyContent: "space-between",
                              }}
                            >
                              {/* Notification Icon */}

                              <Box sx={{ width: "30px", height: "30px" }}>
                                <img
                                  src={NotificationIcon}
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    marginTop: "5px",
                                  }}
                                />
                              </Box>

                              {/* Notification Content */}
                              <Box
                                sx={{
                                  width: "calc(100% - 50px)",
                                  flex: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "10px",
                                  alignItems: "start",
                                  justifyContent: "space-between",
                                }}
                              >
                                {/* Title */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                      width: "calc(100% - 80px)",
                                      color: "#000",
                                      fontWeight: "400",
                                      fontSize: "14px",
                                      wordWrap: "break-word",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {item?.title}
                                  </Typography>
                                  <Box
                                    sx={{
                                      width: "80px",
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      sx={{
                                        color: "#000",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {format}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Message */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#000",
                                      fontWeight: "100",
                                      fontSize: "14px",
                                      width: "calc(100% - 40px)",
                                      wordWrap: "break-word",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {item?.message}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          );
                        })}
                      </>
                    ))
                  )}
                  {
                    <Box
                      ref={ref}
                      sx={{
                        width: "100%",
                        display: "flex",
                        // display:"flex",
                        // border:"solid red",
                        height: "20px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {paginationLoader && inView && <Loader />}
                    </Box>
                  }
                </TabPanel>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Notifications;
